import './wpPublicPath';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import { initTrackingListener } from './lib/trackingLoader';
import { installWpLinkIntercept } from './lib/wpLinkIntercept';

initTrackingListener();
installWpLinkIntercept();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
